import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_LINK, EMAIL } from '../config';

function Navbar() {
  const [showPhone, setShowPhone] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(EMAIL).then(() => {
      alert('כתובת המייל הועתקה!');
    }, () => {
      alert('שגיאה בהעתקת המייל.');
    });
  };

  const handleCallClick = (e) => {
    if (window.innerWidth > 980) {
      e.preventDefault();
      setShowPhone(true);
    }
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav id="nav">
      <div className="nav-top-row">
        <NavLink to="/" className="logo" onClick={closeMenu}>
          <img src="/images/assets/logo.png" alt="לוגו דביר הנדסה ובניה" />
        </NavLink>

        <div className="nav-quick-actions">
          <a href={`tel:${PHONE_TEL}`} className="quick-action-button" aria-label="התקשרו אלינו">
            <i className="fa fa-phone"></i>
          </a>
          <a
            href={WHATSAPP_LINK}
            className="quick-action-button quick-action-whatsapp"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="שלחו הודעת וואטסאפ"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
          <button
            type="button"
            className="nav-toggle"
            aria-label={menuOpen ? 'סגור תפריט' : 'פתח תפריט'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(open => !open)}
          >
            <i className={`fa ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
      </div>

      <div className={`nav-menu${menuOpen ? ' is-open' : ''}`}>
        <ul className="links">
          <li><NavLink to="/" onClick={closeMenu} end>בית</NavLink></li>
          <li><NavLink to="/projects" onClick={closeMenu}>פרויקטים</NavLink></li>
          <li><NavLink to="/contact" onClick={closeMenu}>צור קשר</NavLink></li>
        </ul>

        <ul className="nav-left">
          <li>
            <div className="email-box" onClick={copyToClipboard} title="העתק כתובת מייל">
              <i className="fa fa-envelope icon"></i>
              <span>{EMAIL}</span>
            </div>
          </li>
          <li>
            <a
              href={WHATSAPP_LINK}
              className="whatsapp-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp icon"></i>וואטסאפ
            </a>
          </li>
          <li>
            {showPhone ? (
              <a href={`tel:${PHONE_TEL}`} className="call-button phone-display">{PHONE_DISPLAY}</a>
            ) : (
              <a href={`tel:${PHONE_TEL}`} className="call-button" onClick={handleCallClick}>
                <i className="fa fa-phone icon"></i>התקשרו אלינו
              </a>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
